import { ComponentPropsWithoutRef, forwardRef, isValidElement, memo, ReactElement } from "react"

type SVGProps = ComponentPropsWithoutRef<"svg">

export const IconAccount = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref} fill="none">
        <path
          d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCart = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref} fill="none">
        <path
          d="M2.05 2.05H4.05L5.12086 7.05M5.12086 7.05L6.71 14.47C6.80758 14.9249 7.06067 15.3315 7.42571 15.6199C7.79076 15.9082 8.24491 16.0603 8.71 16.05H18.49C18.9452 16.0493 19.3865 15.8933 19.741 15.6078C20.0956 15.3224 20.3421 14.9245 20.44 14.48L22.09 7.05H5.12086ZM9 21C9 21.5523 8.55229 22 8 22C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20C8.55229 20 9 20.4477 9 21ZM20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21C18 20.4477 18.4477 20 19 20C19.5523 20 20 20.4477 20 21Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronDown = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path d="M6 10L12 16L18 10" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor"></path>
      </svg>
    )
  }),
)

export const IconChevronUp = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path d="M18 14L12 8L6 14" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor"></path>
      </svg>
    )
  }),
)

export const IconClose = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M18 6L12 12M12 12L6 18M12 12L6 6M12 12L18 18"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconFlip = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M4 10C4 8.41775 4.46919 6.87103 5.34824 5.55544C6.22729 4.23985 7.47672 3.21447 8.93853 2.60897C10.4003 2.00347 12.0089 1.84504 13.5607 2.15372C15.1126 2.4624 16.538 3.22433 17.6569 4.34315C18.7757 5.46197 19.5376 6.88743 19.8463 8.43928C20.155 9.99113 19.9965 11.5997 19.391 13.0615C18.7855 14.5233 17.7602 15.7727 16.4446 16.6518C15.129 17.5308 13.5823 18 12 18H4M8 14L4 18L8 22"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconHide = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M15 18L14.278 14.75M2 8C2.72416 9.98447 4.02178 11.7071 5.72575 12.9503M5.72575 12.9503C5.78268 12.9918 5.84007 13.0328 5.8979 13.0733C7.68667 14.3247 9.81695 14.9959 12 14.9959C14.1831 14.9959 16.3133 14.3247 18.1021 13.0733C18.1599 13.0328 18.2173 12.9918 18.2743 12.9503M5.72575 12.9503L4 15M5.72575 12.9503L5.726 12.95M18.2743 12.9503C19.9782 11.7071 21.2758 9.98447 22 8M18.2743 12.9503L20 15M18.2743 12.9503L18.274 12.95M9 18L9.722 14.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconMinimise = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M14 10L21 3M14 4V10H20M3 21L10 14M10 20V14H4"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlaceholder = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <circle cx="12" cy="12" r="4" fill="currentColor"></circle>
      </svg>
    )
  }),
)

export const IconPoster = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M14 2H6C5.46957 2 4.96086 2.21072 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2C14.3166 1.99949 14.6301 2.06161 14.9225 2.18277C15.215 2.30394 15.4806 2.48176 15.704 2.706L19.292 6.294C19.5168 6.51751 19.6952 6.78335 19.8167 7.07616C19.9382 7.36898 20.0005 7.68297 20 8M14 2V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89465 14.7348 8 15 8L20 8M20 17L18.704 15.704C18.252 15.2521 17.6391 14.9983 17 14.9983C16.3609 14.9983 15.748 15.2521 15.296 15.704L9 22M12 12C12 13.1046 11.1046 14 10 14C8.89543 14 8 13.1046 8 12C8 10.8954 8.89543 10 10 10C11.1046 10 12 10.8954 12 12Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSearch = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M21 21L16.66 16.66M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconUnhide = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
        <path
          d="M2.06153 12.3474C1.97819 12.1229 1.97819 11.8759 2.06153 11.6514C2.87323 9.68324 4.25104 8.00042 6.0203 6.81628C7.78955 5.63214 9.87057 5 11.9995 5C14.1285 5 16.2095 5.63214 17.9788 6.81628C19.748 8.00042 21.1258 9.68324 21.9375 11.6514C22.0209 11.8759 22.0209 12.1229 21.9375 12.3474C21.1258 14.3155 19.748 15.9983 17.9788 17.1825C16.2095 18.3666 14.1285 18.9988 11.9995 18.9988C9.87057 18.9988 7.78955 18.3666 6.0203 17.1825C4.25104 15.9983 2.87323 14.3155 2.06153 12.3474ZM14.9995 11.9994C14.9995 13.6562 13.6564 14.9994 11.9995 14.9994C10.3427 14.9994 8.99953 13.6562 8.99953 11.9994C8.99953 10.3425 10.3427 8.99938 11.9995 8.99938C13.6564 8.99938 14.9995 10.3425 14.9995 11.9994Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        ></path>
      </svg>
    )
  }),
)

export type IconName =
  | "account"
  | "cart"
  | "chevronDown"
  | "chevronUp"
  | "close"
  | "flip"
  | "hide"
  | "minimise"
  | "placeholder"
  | "poster"
  | "search"
  | "unhide"

type IconProps = Omit<SVGProps, "name"> & { name: IconRef | undefined }
type IconComponent = (props: SVGProps) => ReactElement
type IconSet = { [K in IconName]: IconComponent }

export const ICONS = {
  account: IconAccount,
  cart: IconCart,
  chevronDown: IconChevronDown,
  chevronUp: IconChevronUp,
  close: IconClose,
  flip: IconFlip,
  hide: IconHide,
  minimise: IconMinimise,
  placeholder: IconPlaceholder,
  poster: IconPoster,
  search: IconSearch,
  unhide: IconUnhide,
} as IconSet

export type IconRef = IconName | ReactElement

export function Icon(props: IconProps) {
  if (!props.name) return null
  if (isValidElement(props.name)) {
    return props.name
  }
  const { name, ...rest } = props
  if (typeof name === "string" && name in ICONS) {
    const IconComponent = ICONS[name]
    return <IconComponent {...rest} className={"icon" + (props.className ? " " + props.className : "")} />
  }
  return props.name
}
